import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
export function WhySection() {
  return <section className="py-20 bg-white" data-id="element-288">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-289">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-290">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="text-center lg:text-left" data-id="element-291">
            <span className="text-[#10B981] font-bold uppercase tracking-wider text-sm" data-id="element-292">
              The Life You Get Back
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1B5E20] mt-2 mb-8" data-id="element-293">
              Imagine this:
            </h2>

            <div className="space-y-4 text-xl text-[#374151] leading-relaxed" data-id="element-294">
              <p data-id="element-295">You wake up without the swollen face</p>
              <p data-id="element-296">Your jeans fit without the struggle</p>
              <p data-id="element-297">Your rings don't feel tight anymore</p>
              <p data-id="element-298">You stop sucking it in all day</p>
              <p className="pt-4 font-medium text-[#1B5E20]" data-id="element-299">
                People start saying: "You look different..."
              </p>
              <p data-id="element-300">Not because you became someone else...</p>
              <p className="font-bold text-2xl text-[#10B981]" data-id="element-301">
                Because you finally feel like you again.
              </p>
            </div>

            <div className="mt-10 inline-flex items-center justify-center p-4 bg-[#F0FFF4] rounded-full text-[#1B5E20] font-bold" data-id="element-302">
              <Heart className="w-5 h-5 text-[#10B981] mr-2 fill-current" data-id="element-303" />
              That's what LymphoriaX™ really supports.
            </div>
          </motion.div>

          {/* Visual Side */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-304">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl aspect-[4/5]" data-id="element-305">
              <img src="https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?auto=format&fit=crop&q=80&w=1000" alt="Woman feeling confident and light" className="w-full h-full object-cover" data-id="element-306" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1B5E20]/40 to-transparent" data-id="element-307" />
              <div className="absolute bottom-6 left-6 right-6 bg-white/90 backdrop-blur-sm p-4 rounded-xl shadow-lg" data-id="element-308">
                <p className="text-[#1B5E20] font-bold text-lg italic" data-id="element-309">
                  "I finally recognize myself in the mirror again."
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}